import { ComponentPropsWithRef, ForwardedRef, forwardRef } from 'react';
import styles from './signupForm.module.css';

const SignupForm = (
  props: ComponentPropsWithRef<'form'>,
  ref?: ForwardedRef<HTMLFormElement>
) => {
  return (
    <form className={styles.signupForm} {...props} ref={ref}>
      {props.children}
    </form>
  );
};

export default forwardRef(SignupForm);
